// add loader when click button submit
const contactForm = document.querySelector('.wpcf7-form');
const buttonSubmit = document.querySelector(".contact__button");
const buttonSpinner = document.querySelector(".contact__button-spinner");

buttonSubmit.addEventListener('click', (el) => {
    buttonSpinner.style.display = "block";
});

contactForm.addEventListener('wpcf7submit', () => {
    buttonSpinner.style.display = "none";
});

// direct to thanks page
contactForm.addEventListener('wpcf7mailsent', function (event) {
    location = thanksUrl;
}, false);